const app = angular.module('msi.products.oneTimeDifferences', [
  require('./one-time-differences.factory'),
  require('./one-time-differences-warnings'),
  require('./one-time-differences-explanation.controller')
]);

module.exports = app.name;
